module.exports = __webpack_public_path__ + "static/img/biao1.10529b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/biao1.png
// module id = qSfL
// module chunks = 0